import axios from 'axios';
import { clearAuthTokens, ensureFreshToken, refreshAccessToken } from './tokenRefresh';

const MAX_RETRIES = 5;
const AUTH_ENDPOINTS = ['login/', 'validate-login/', 'refresh/'];

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_MAIN_URL
});

axiosInstance.interceptors.request.use(
  async config => {
    const requestUrl = config.url || '';
    if (AUTH_ENDPOINTS.some(ep => requestUrl.includes(ep))) {
      return config;
    }
    const token = await ensureFreshToken();
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    const requestUrl = originalRequest?.url || '';

    if (!originalRequest || requestUrl.includes('refresh/')) {
      return Promise.reject(error);
    }

    if (error.response?.status === 401 && (!originalRequest._retry || originalRequest._retry < MAX_RETRIES)) {
      originalRequest._retry = (originalRequest._retry || 0) + 1;

      const accessToken = await refreshAccessToken();

      if (!accessToken) {
        return Promise.reject(error);
      }

      originalRequest.headers = originalRequest.headers || {};
      originalRequest.headers['Authorization'] = 'Bearer ' + accessToken;
      axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken;

      return axiosInstance(originalRequest);
    }

    if (error.response?.status === 401) {
      clearAuthTokens();
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
